import '../../../App.css';
import { changeTool } from "../../../store/tool";
import moveIcon from "../../pictures/2D_editor_icon_move.png";
import splitIcon from "../../pictures/2D_editor_icon_snap_to_midle.png";
import lineIcon from "../../pictures/2D_editor_icon_polyline.png";
import polygonIcon from "../../pictures/2D_editor_icon_polygon.png";
import imageIcon from "../../pictures/2D_editor_icon_rectangle.png";
import selectIcon from "../../pictures/2D_editor_icon_select.png";
import rect_selectIcon from "../../pictures/2D_editor_icon_select_box.png";
import circleIcon from "../../pictures/2D_editor_icon_circle.png";
import textIcon from "../../pictures/2D_editor_icon_list.png";
import rotationIcon from "../../pictures/2D_editor_icon_rotate.png";
import mirrorIcon from "../../pictures/2D_editor_icon_mirror.png";
import ToolbarButton from "./toolbarButton";
import { useAppDispatch } from '../../../store/hooks'
import { endRubberline } from '../../../store/interaction';

interface ToolbarProps { }

const Toolbar = (toolbarProps: ToolbarProps) => {
    const dispatch = useAppDispatch()

    function clickToolToChange(tool: ToolType) {
        dispatch(endRubberline());
        dispatch(changeTool(tool));
    }

    return (
        <div className="toolbar">
            <ToolbarButton
                onClick={() => (clickToolToChange("select"))}
                icon={selectIcon}
                tooltip={"select"}
                toolname={"select"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("rect_select");
                }}
                icon={rect_selectIcon}
                tooltip={"rect_select"}
                toolname={"rect_select"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("line")
                }}
                icon={lineIcon}
                tooltip={"line"}
                toolname={"line"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("polygon")
                }}
                icon={polygonIcon}
                tooltip={"polygon"}
                toolname={"polygon"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("circle")
                }}
                icon={circleIcon}
                tooltip={"circle"}
                toolname={"circle"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("text")
                }}
                icon={textIcon}
                tooltip={"text"}
                toolname={"text"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("symbol")
                }}
                icon={imageIcon}
                tooltip={"symbol"}
                toolname={"symbol"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("move")
                }}
                icon={moveIcon}
                tooltip={"move"}
                toolname={"move"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("rotation")
                }}
                icon={rotationIcon}
                tooltip={"rotation"}
                toolname={"rotation"}
            ></ToolbarButton>
            <ToolbarButton
                onClick={() => {
                    clickToolToChange("mirror")
                }}
                icon={mirrorIcon}
                tooltip={"mirror"}
                toolname={"mirror"}
            ></ToolbarButton>

            <ToolbarButton
                onClick={() => {
                    clickToolToChange("split")
                }}
                icon={splitIcon}
                tooltip={"split"}
                toolname={"split"}
            ></ToolbarButton>
        </div>
    );
}


export default Toolbar;
